const normalizeFederalTaxNumber = (value) => {
  if (!value) {
    return value;
  }

  return value.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
};

export default normalizeFederalTaxNumber;
